import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { pluralize } from "utils/pluralize";
import type {
  ReviewActionFn,
  ReviewFieldAction,
  ReviewSection,
} from "v2/types/extractionReview.types";
import { countReviewFields } from "v2/utils/countReviewFields";
import { FieldRow } from "./FieldRow";

type ReviewSectionItemProps = {
  section: ReviewSection;
  onAction: ReviewActionFn;
  pendingActionFor: (fieldId: string) => ReviewFieldAction | null;
};

export const ReviewSectionItem = ({
  section,
  onAction,
  pendingActionFor,
}: ReviewSectionItemProps) => {
  const { conflicting, review_remaining: remaining } = countReviewFields(
    section.fields
  );
  const value = String(section.category_group);

  return (
    <Accordion.Item value={value}>
      <Accordion.Trigger showArrow arrowPosition="right">
        {/* t-normal-case undoes the Trigger's built-in t-capitalize. */}
        <div className="t-flex t-flex-col t-items-start t-gap-1 t-normal-case">
          <span className="t-text-subtext t-text-text-60">{section.label}</span>
          <span className="t-flex t-items-center t-gap-2 t-text-body-sm-lite t-text-neutral-50">
            {conflicting > 0 && (
              <>
                <span>
                  {pluralize(
                    conflicting,
                    "Conflicting value",
                    "Conflicting values"
                  )}
                </span>
                <span className="t-h-0.5 t-w-0.5 t-rounded-full t-bg-neutral-50" />
              </>
            )}
            <span>
              {pluralize(remaining, "field to review", "fields to review")}
            </span>
          </span>
        </div>
      </Accordion.Trigger>
      <Accordion.Content>
        <div className="t-flex t-flex-col t-gap-4">
          {section.fields.map((field, i) => (
            <div
              key={field.field_id}
              className={
                i > 0
                  ? "t-border-0 t-border-t t-border-solid t-border-neutral-10 t-pt-4"
                  : ""
              }
            >
              <FieldRow
                field={field}
                onAction={onAction}
                pendingAction={pendingActionFor(field.field_id)}
              />
            </div>
          ))}
        </div>
      </Accordion.Content>
    </Accordion.Item>
  );
};
